import { getBalancingServicesVolumeJsonData } from "api/dataVisualisation/balancingServicesVolume/balancingServicesVolume";
import {
  MarketViewBmuFilters,
  filterBmuIds,
  hasAnyFilters,
} from "components/components/balancingMechanism/marketView/MarketViewFilters/helpers";
import useRequest, { RequestStatus } from "hooks/useRequest";
import { BalancingServicesVolumeModel } from "models/bmuData/balancingServicesVolumeModel";
import { BmuModel } from "models/bmuData/bmuModel";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { useCallback } from "react";

const useMarketViewBalancingServicesVolumeData = (
  selectedDate: Date,
  bmuFilters: MarketViewBmuFilters,
  bmuData: BmuModel[] | null
): {
  data: BalancingServicesVolumeModel[] | null;
  status: RequestStatus;
  request: () => void;
} => {
  const {
    data,
    status,
    request: fetchBalancingServicesVolumeData,
  } = useRequest(getBalancingServicesVolumeJsonData);

  const fetchData = useCallback(() => {
    if (!selectedDate) {
      return;
    }

    const dateFilter = new DateFilterModel(selectedDate, selectedDate);
    if (bmuData && hasAnyFilters(bmuFilters)) {
      const bmUnits = filterBmuIds(bmuData, bmuFilters);
      fetchBalancingServicesVolumeData(dateFilter, bmUnits);
    } else {
      fetchBalancingServicesVolumeData(dateFilter);
    }
  }, [bmuData, bmuFilters, selectedDate, fetchBalancingServicesVolumeData]);

  return {
    data: data?.data ?? null,
    status,
    request: fetchData,
  };
};

export default useMarketViewBalancingServicesVolumeData;
